// ============================================================
// translations.js — Importación y exportación de locales JSON
// ============================================================
import es from '../locales/es.json';
import en from '../locales/en.json';
import pt from '../locales/pt.json';

export const translations = {
  es,
  en,
  pt,
};

export function getTranslation(key, lang = 'es') {
  const dict = translations[lang] || translations.es;
  return dict[key] || translations.es[key] || key;
}
